import institutionAPI from 'services/institutionAPI'

export default async function readPersonDocuments() {
  const response = await institutionAPI({
    url: '/account/document/profile',
    method: 'GET',
  })

  return response
}
